import React from "react";
import Header from "../Header";
import Footer from "../Footer";

import { Link } from "react-router-dom";
import AudioPlayer from "../Audio/AudioPlayer";

const BlogDetails12 = (props) => {
  const img1 = "/assets/wp-content/uploads/2018/12/ramdev-gallery14.jpg";
  return (
    <>
     <meta name="keywords" content="બાબા રામદેવ , રામદેવજી,  રામદેવ પીર, રામશા પીર, Baba Ramdev, Ramdevji, Ramdev Pir, Ramshapir" />
      
      {/* <div className="body_wrap">
        <div className="page_wrap"> */}


      <Header />
      <div
        data-elementor-type="cpt_layouts"
        data-elementor-id="46"
        className="elementor elementor-46"
      >
        <section
          className="elementor-section elementor-top-section elementor-element elementor-element-52ebb12  elementor-section-boxed elementor-section-height-default elementor-section-height-default"
          data-id="52ebb12"
          data-element_type="section"
          data-settings='{"background_background":"classic"}'
          style={{ height: "30rem", marginBottom: "5rem" }}
        >
          <div className="elementor-background-overlay"></div>
          <div className="elementor-container elementor-column-gap-extended">
            <div
              className="elementor-column elementor-col-100 elementor-top-column elementor-element elementor-element-ae9d67e sc_inner_width_none sc_layouts_column_icons_position_left"
              data-id="ae9d67e"
              data-element_type="column"
            >
              <div className="elementor-widget-wrap elementor-element-populated">
                <section
                  className="elementor-section elementor-inner-section elementor-element elementor-element-fcf91b3 elementor-section-boxed elementor-section-height-default elementor-section-height-default"
                  data-id="fcf91b3"
                  data-element_type="section"
                >
                  <div className="elementor-container elementor-column-gap-extended">
                    <div
                      className="elementor-column elementor-col-100 elementor-inner-column elementor-element elementor-element-93dfaf4 sc_inner_width_none sc_layouts_column_icons_position_left"
                      data-id="93dfaf4"
                      data-element_type="column"
                    >
                      <div className="elementor-widget-wrap elementor-element-populated">
                        <div
                          className="sc_layouts_item elementor-element elementor-element-847c2c5 sc_fly_static elementor-widget elementor-widget-spacer"
                          data-id="847c2c5"
                          data-element_type="widget"
                          data-widget_type="spacer.default"
                          style={{ height: "8rem" }}
                        >
                          <div className="elementor-widget-container">
                            <div className="elementor-spacer">
                              <div className="elementor-spacer-inner"></div>
                            </div>
                          </div>
                        </div>
                        <div
                          className="sc_layouts_item elementor-element elementor-element-8fe49e3 sc_fly_static elementor-widget elementor-widget-trx_sc_layouts_title"
                          data-id="8fe49e3"
                          data-element_type="widget"
                          data-widget_type="trx_sc_layouts_title.default"
                        >
                          <div className="elementor-widget-container">
                            <div
                              id="trx_sc_layouts_title_515615674"
                              className="sc_layouts_title sc_align_center with_content without_image without_tint"
                            >
                              <div className="sc_layouts_title_content">
                                <div className="sc_layouts_title_title">
                                  {" "}
                                 
                                </div>
                                <div className="sc_layouts_title_breadcrumbs">
                                  <div className="breadcrumbs">
                                    
                                   
                                  </div>
                                </div>
                              </div>
                            </div>{" "}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* <div className="menu_mobile_overlay"></div>
      <div className="menu_mobile menu_mobile_fullscreen scheme_inherit">
        <div className="menu_mobile_inner">
          <a className="menu_mobile_close icon-cancel"></a>
          <Link to={'/'} className="sc_layouts_logo">

            <img
              src={logoimg}
              alt="Vihara"
              width="134"
              height="78"
            />{" "}
          </Link>
          <nav
            className="menu_mobile_nav_area"
            itemScope
            itemType="//schema.org/SiteNavigationElement"
          >
            <ul id="menu_mobile_1510458944">
              <li
                id="menu_mobile-item-203"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-203"
              >
                <a href="/">
                  <span>Home</span>
                </a>

              </li>
              <li
                id="menu_mobile-item-204"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-204"
              >
                <a href="#">
                  <span>Gallery</span>
                </a>
                <ul className="sub-menu">
                  <li
                    id="menu_mobile-item-209"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-209"
                  >
                    <a href="/Audio">
                      <span>Audio</span>
                    </a>
                  </li>
                  <li
                    id="menu_mobile-item-208"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-208"
                  >
                    <a href="/Video">
                      <span>Video</span>
                    </a>
                  </li>
                  <li
                    id="menu_mobile-item-206"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-206"
                  >
                    <a href="/Gallery2">
                      <span>Images</span>
                    </a>
                  </li>

                </ul>
              </li>
              <li
                id="menu_mobile-item-224"
                className="menu-item menu-item-type-custom menu-item-object-custom current-menu-ancestor current-menu-parent menu-item-has-children menu-item-224"
              >
                <a href="#">
                  <span>About</span>
                </a>
                <ul className="sub-menu">
                  <li
                    id="menu_mobile-item-447"
                    className="menu-item menu-item-type-post_type menu-item-object-page current-menu-item page_item page-item-407 current_page_item menu-item-447"
                  >
                    <a
                      href="/About"
                      aria-current="page"
                    >
                      <span>Ashram</span>
                    </a>
                  </li>

                  <li
                    id="menu_mobile-item-449"
                    className="menu-item menu-item-type-post_type menu-item-object-page menu-item-449"
                  >
                    <a href="/plan-visit">
                      <span>Plan a Visit</span>
                    </a>
                  </li>
                </ul>
              </li>

              <li
                id="menu_mobile-item-316"
                className="menu-item menu-item-type-custom menu-item-object-custom menu-item-has-children menu-item-316"
              >
                <a href="/BlogMain">
                  <span>Stories</span>
                </a>
              </li>
              <li
                id="menu_mobile-item-312"
                className="menu-item menu-item-type-post_type menu-item-object-page menu-item-312"
              >
                <a href="/Books">
                  <span>Books</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
 */}



      <div className="page_content_wrap blog-details">
        <div className="content_wrap" >
          <div className="content">
            <div id="container" className="give-wrap container">
              <div id="content" role="main">
                <div
                  id="give-form-288-content"
                  className="post-288 give_forms type-give_forms status-publish has-post-thumbnail"
                >
                  <div
                    id="give-sidebar-left"
                    className="give-sidebar give-single-form-sidebar-left"
                  >
                    <div className="images">
                      <img
                        width="1024"
                        height="576"
                        src={img1}
                        className="attachment-large size-large wp-post-image blog-img"
                        alt=""
                        decoding="async"
                        sizes="(max-width: 1024px) 100vw, 1024px"
                      />
                    </div>
                  </div>
                  <div className="summary entry-summary">
                    <h2 itemProp="name" className="give-form-title entry-title">
                      સાત જન્મની સેવિકા ડાલીબાઇ

                    </h2>{" "}
                    <div
                      id="give-form-288-wrap"
                      className="give-form-wrap give-display-onpage"
                    >
                      <div className="give-goal-progress">
                        <div
                          className="raised blog-title"
                          
                        >
                          <span className="income">સાત જન્મની સેવિકા ડાલીબાઇ
                          </span>
                        </div>
                      </div>

                      <div
                        id="give-form-content-288"
                        className="give-form-content-wrap give_pre_form-content"
                      >
                        <p className="paragraph-content">
                          ગોમટ નામના ગામનો એક કઠિયારો જંગલમાંથી લાકડાનો બારો વર્ષ ગામ * ખાવાનો વિચાર કર્યો. તે ભારો નીચે મૂકીને બેઠો. એટલામાં તેણે જમીનમાં હ આવતો હતો. રસ્તામાં એક પીંપળના વૃક્ષની છાયા જોઈ. તેણે બે કડી બેસી
                          રડવાનો અવાજ સાંભળ્યો.
                          એ જ ગામના રાજપૂતની દીકરી લાંબી મૂર્છાના ઝોબામાં પડી હતી ! ઘણી વાર સુધી રાહ જોવા છતાં તે સળવળી નહીં એટલે બધાએ તેને મરેલી માની અને તેને લઈ જઈ પીંપળ નીચે ખાડો ખોદી તેની અંદર દાટી પાછા ફર્યા. થોડી વાર થઈ કેટલામાં એક કઠિયારો ત્યાં આવ્યો. તેને માટીના ઢગલા પાસે કોઈ રડતું હોય તેનો અવાજ સંભળાયો. તેથી તેણે ઢગલો ફંફોળ્યો અને અંદર જોયું તો એક નાનકડી નોકરી રડતી હતી ! તેણે એ છોકરીને બહાર કાઢી. પાસે રાખેલી પછેડીને પાથરી મને તેની પર સુવાડી. લાંબા સમયનો ઝોબો વળતાં એ મૃત્યુથી બચી અને બેઠી ઈ. પ્રભુની અકળતાનો વિચાર કરતો એ કઠિયારો છોકરીના મુખ સામે જોઈ રહ્યો
                          હતો.
                          ચોપાઈ
                          ચર્મકાર અખૈયા નામે, નિવાસ એનો રણુંજા ગામે,
                          પતિ પત્ની આગળ લઈ લાવે, કઠિયારો બાળક બતલાવે. રણુંજા ગામનો અખૈયા નામનો ચમાર તથા તેની પત્ની ત્યાં આવ્યાં. ગોમટના | વગડામાં પીળાં હળદરવર્ષાં ફૂલથી આવળો ખીલેલી હતી. મહીં જાડી છાલવાળી | *વળનું જંગલ હોવાથી અખૈયા ચમાર એ આવળ લઈ જઈ કુંડમાં પલાળતો અને | માં પકવતો. આજે પણ અખૈયો આવળના ભારાને પાડા પર ગોઠવી આ માર્ગે | કિળ્યો. ઝાડ નીચે કઠિયારાને જોઈ તેઓ પતિપત્ની ત્યાં વિસામો લેવા બેઠાં. | ળકને જોઈ અખૈયાની પત્નીએ પૂછ્યું : ‘ભાઈ ! આવા ધોમધખતા તાપમાં આ | ધ જેવા બાળકને સાથે શીદ લાવ્યો છે વીરા ?' કઠિયારો બોલ્યો.

                        </p>
                        <p className="paragraph-content">
                          દોહા
                          ભૂષિમાં રોતી હતી, મેં કાઢી છે. બહાર;
                          કહો આ કોને સોંપવી, એનો થાય વિચાર ?
                          ભાઈ ! આ બાળકને મરેલું જાણી કોઈ દાટી ગયું હતું, જુઓ ! સામે
                          **
                          છે, તેમાં આ બાલિકા દટાયેલી હતી. એનો અવાજ સાંભળીને મેં ખાડો કો માટી ખસેડી અને આ છોકરીને બહાર કાઢી છે. ઘેર એનું પાલનપોષણ કરે કોઈ નથી. હું એકલો જ છું. હવે આ બાળકી કોને સોંપવી ? એ રહ્યો છું ?' કઠિયારાએ વિગતથી જણાવતાં કહ્યું.
                          વસ્તુ
                          આંટી, દોરો, કાંસકી વગેરે જોતાં તરત જ લઈને આવ્યો અને બોલ્યો કે, આ કો આ વાત સાંભળી અખૈયો ખાડો જોવા ગયો, ત્યાં એણે અંદર પડેલી મૂકતા નથી. મેં આવું મારા ગુરુ ભૂતનાથ પાસેથી સાંભળ્યું છે. ‘ભાઈ ! મૂંઝાશો નહીં. આ બાળકી અમે લઈ જઈએ તો ?' બાઈએ પોતાની ઇચ્છા જણાવ કઠિયારાએ કહ્યું : ‘એ તો ઘણું સારું બહેન !'
                          “પણ એક શરત. આ બાળકી અમારા ગુરુ બાળનાથને બતાવી તેમની સાક્ષીએ સોંપવી. અમે મોટી કરીએ ને મોટી થયા પછી તમે પાછી લઈ જાવ તો ?’ અખૈયાન પત્નીએ શંકા કરતાં કહ્યું .
                          ‘તો ચાલો હું ગુરુ પાસે આવીને સોંપું.' કઠિયારાએ કહ્યું.
                          ત્રણે જણા બાળનાથના આસને આવ્યાં. ખાડામાંથી નીકળેલી બાળકીને તે બાઈએ તેડી લીધી હતી. તે તેડેલી બાળકીને બાળનાથ સામે મૂકી અને આંટી, દોરો તથા કાંસકી બતાવીને સવિસ્તાર વાત કહી.
                          બાળનાથે છોકરીને જોઈ તો તેના મુખાર્વિંદ ઉપરથી દિવ્ય વિભૂતિ જણાઈ. તેમણે છોકરીના નાભીકમળે કાન રાખી યોગશક્તિથી પરાવાણીમાં તેના પૂર્વજન્મની કથા સમજી લીધી.
                          બાળનાથે આંટી, દોરો અને કાંસકી પોતાની પાસે રાખી બાળકી અખૈયા ચમારને સોંપી દીધી . અખૈયો પણ રામદેવજીનો પરમ ભક્ત હતો. તેની પત્ની પ નિમધારી હતી. હંમેશાં તે ધૂપદીપ કરીને જે રાંધ્યું હોય તેનો થાળ રામદેવજીને ધરાવી પછી એ વધેલું અન્ન પ્રસાદ ગણી ખાતી હતી. પીંપળ વૃક્ષની ડાળી નીચેથી બાળકી મળેલી હોવાથી તેનું નામ ‘ડાલી’ રાખ્યું. પોતાને સંતાન ન હોવાથી ડાલીને

                        </p>
                        <p className="paragraph-content">
                          સાત વરસની થતાં એ પોતાની ગાયને ગામના ગૌવ્ઝ ઝી મૂકા અને સાંજે પાછી લાવવા ગૌધણની વાટ જોઈ ગામને પાદરે ઊભી રહે. જ્યારે આવે ત્યારે તેમાંથી પોતાની ગાયને લઈને ઘેર આવે. તેનાં વિશ્વ મીઠીવાણીને લીધે ગૌધણવાળા ગોવાળોએ એને વારું ચારવાનું કામ
                          ||૨ક
                          સાંધ્યું.
                          શુંજાના પાદરમાં ‘ધણઝોડ' નામનો વિશાળ જમીનનો પટ હોવાથી તેમાં ગામનું ગામધણ અને રાજધણ એમ બે વિભાગનાં ગોધણ ત્યાં ભેગાં થતાં હતાં. ડાલીબાઈ પાસે આવી ઊભી રહી. ડાલીબાઈએ એની નજરમાં શેતાની નજર એક દિવસ એમાં રામદેવજીની પ્રિય 'રામેતી' ગાય રાજધલમાંથી છૂટી પડી, મેળવતાં તેને રામેતી ગાયની આંખમાં દિવ્ય તેજ દેખાયું, તેથી તેણે માથું નમાવી ચંદન કર્યું. થોડી વાર પછી તે ગાય પાછી વળી રાજધણમાં ભળી ગઈ. આ દૃશ્ય ગોવાળોને નવાઈ લાગી.
                          ઈ
                          બીજે દિવસે ડાલીબાઈ કંકુ ભરેલી કંકાવટી સાથે લઈને આવ્યાં. ડાલીબાઈને ખેતાં જ રામેતી ગાય ફરી પાછી રાજધણમાંથી છૂટી પડી ડાલીબાઈ સામે આવી ભી રહી. ડાલીબાઈએ એના કપાળમાં ચાંદલો કરી નમન કર્યું. તે પછી ગાય તરત જ પાછી વળી ગઈ. પૂર્વજન્મના વિખૂટા પડેલા જીવાત્માઓનું પુનર્મિલન થતું ઢોય તેમ ગોવાળોને લાગ્યું. ગોવાળો ગાયો ખીલે બાંધીને ડાયરામાં આવ્યા. અજમલજી, વીરમદેવજી, રામદેવજી અને ગામના પ્રતિષ્ઠિત આગેવાનો ડાયરામાં બેઠા હતા. ત્યાં આવીને ગોવાળોએ રામેતી ગાયની વાત કરી.
                          બીજે દિવસે ગૌધણ સમયે પંચકલ્યાણી ઘોડા પર સવાર થઈ વીરમદેવજી અને લીલુડા ઘોડે સવાર થઈ રામદેવજી આવ્યા અને ધણથી થોડે દૂર ધોડા થોભાવી ઊભા રહ્યા. એ વખતે ડાલીબાઈ પોતાની ગાય મૂકવા આવી. તેમની ગાય ઘામાં ભળી ગઈ અને રામેતી ગાય ધણમાંથી નીકળી અને ડાલીબાઈ સામે આવીને ઊભી રહી. લીબાઈએ એને ચાંલ્લો કરી નમન કર્યું. તે પછી તે પાછી વળી પોતાના રાજધણમાં
                          ભળી ગઈ.
                          આ જોઈ વી૨મદેવજીને આશ્ચર્ય લાગ્યું. ‘બંનેને કેવો પ્રેમ છે ?' એટલું કહીને લીબાઈ સામે આવી તેની દૃષ્ટિ સામે જોઈ રામદેવજીએ ડાલીબાઈના હૃદયને વાંચી વીધું અને મનમાં બોલ્યા : 'તું પાછી આવી ?' વીરમદેવજી બીજી દિશાએ જોઈ ધી હતા તેથી તેમણે આ વાતમાં લક્ષ્ય આપ્યું નહીં. રામદેવજી ડાલીબાઈને પૂછવા
                        </p>
                        <p className="paragraph-content">
                          ‘તું કોની દીકરી છે ? તારા બાપનું નામ શું ?'
                          ‘બાપુ ! હું ચમારની દીકરી છું. બાપનું નામ અખૈયો ભગત,
                          ‘અમારા ઘરમાં પાણીનો એક કુંડ છે, વગડામાંથી આવળ લાવીને એની અં નાખે છે, ચામડાંને પલાળે છે તથા રંગે છે અને રંગેલાં ચામડાંને વેચે છે.'
                          ‘એ શું ધંધો કરે છે ?' રામદેવજીએ પૂછ્યું.
                          કહ્યું.
                          ‘અખૈયો ભગત નામ કેમ પડ્યું ?'
                          ‘મારાં મા-બાપ ભગવાન રામાપીરના આસ્થાવાળાં છે, મારે ઘેર રામાપીરનું થાપન છે, એમની સેવાપૂજા અને ભજનભાવમાં અમે સવારના દશ વાગ્યા સુ
                          રહીએ છીએ એટલે લોકો ભગત કહે છે.’
                          ‘ગાયને ચાંલ્લો કરવાનું તારે વ્રત છે ?'
                          એ ગાય ઘણી ગમે છે એટલે હું એ ગાયને ચાંલ્લો કરવા સાથે કંકાવટી લઈને ‘બાપુ ! મારે વ્રત નથી પણ રામદેવજીની ગાયનો મારા પર પ્રેમ છે. મને
                          આવું છું.”
                          ‘કંકાવટીમાં કંકુ છે ? તો અમને ચાંલ્લો કર ને ?’
                          ‘બાપુ ! આપ ઉજળાવરણ છો ! મોટા લોકો છો ! આપને અજાણતાં જવાય તોય આભડછેટ લાગે, અને આપને નાહવું પડે. એટલું તો હું જાણું છું. અમે તો ચમાર વરણ છીએ !’ ડાલીબાઈએ કહ્યું. ‘દીકરી તું અમને ચાંલ્લા કર, બેય ઘોડાને પણ ચાંલ્લા કર, તને અડકવાથી કે તું અમને અડકે તેમાં આભડછેટ લાગતી, નથી. શરીરમાં શું અભડાય છે ? ખરું કોઈ કહેતાં નથી અને તૂત ઊભું કરી રહ્યાં છે ! તું ચાંલ્લા કર દીકરી ! વીરમદેવજીએ હસતાં હસતાં કહ્યું. ડાલીબાઈ રામદેવજીના અને વીરમદેવજીના બંને અશ્વોને ચાંદલા કરી ખૂબ હર્ષમાં આવી ગઈ. તે બોલી ‘જય રામાપીર મહારાજ, આભડછેટ મટાડી આજ.' ડાલીબાઈ હરખઘેલી બની નાચતી કૂદતી પોતાના ઘર તરફ ગઈ અને રામદેવજી અશ્વ ઉપર સવાર થઈ ઘોડા ખેલવવા ગયા. ગોવાળો ધણ લઈને અડવા- આભડવાની વાતો કરતા ગામ તરફ ગયા. આખા ગામમાં રામેતી ગાય દ૨૨ોજ ડાલીબાઈ પાસે ચાંલ્લો કરાવવા જાય છે એની વાત ફેલાઈ ગઈ. આ વાતથી આખા ગામના લોકોમાં પણ ડાલીબાઈ ઉપર શ્રદ્ધા જન્મી.
                          નાની ઉંમરની ચમાર કન્યા ડાલીબાઈની ગૌભક્તિની વાત વીરમદેવજીએ
                        </p>
                        <p className="paragraph-content">
                          અને માતા મિલણદેને કરી. સવારે રાજગેરીમાં અજમલ રામદેવ, દાદા રણસિંહ અને અન્ય પ્રજાજનો અહીલ શુંબાની
                          જાન માંકડ્યો. થોડી વારમાં ચોકીદાર અખૈયા ભગતને તેડી લાવ્યો. અખૈયો આ કર રહ્યા છે. અખૈયા ગમારને કચેરીમાં તેડી લાવવા અજમ ન કરીને કચેરીમાં દરવાજા પાસે ઊભો રહ્યો. અંદર આવવાની એની હિંમત શી નહીં, પાત કંઈક ગુનામાં આવ્યો છે, એમ સમજી મનમાં તે ધ્રૂજતો હતો. અજાજીને એને જોતાં જ કહ્યું : 'અંદર આવે ભાઈ, ત્યાં કેમ ઊભો છે ?” મહારાજ ! અન્નદાતા ! હું ચમાર છું. આભડછેટવાળો ગણાઉં છું. આભડછેટ ? માનવી માનવીમાં આવો અંતરાય ? પ્રશ્ન તો રાજનું અંગ છે ! પ્રજા રાજ્યનો પરિવાર છે ! પ્રજા અને રાજા પરસ્પર સુખદુઃખના સાથી છે, એમાં આભડછેટ હોતી નથી. અંદર આવ અને તું તારી ઓળખાણ આપ.' અજમલજીના આવકારથી અખૈયાનો ભય અને મનના તરંગો તરત શમી ગયા. તે અંદર આવીને કહેવા લાગ્યો : બાપુ મારું નામ અખૈયો, ગામ બહાર તળાવ પાસે ખળાવાડ છે. ત્યાં હું કુટુંબ
                          સાથે રહું છું.
                          દોહા
                          ચામ પલાડી કુંડમાં, કરું પખાલ ને કોશ,
                          કરતો કુલ્લી કુલડાં, કુણાં કેળવી મોશ.
                          મારા વાડામાં મોટો કુંડ ગાળ્યો છે, એમાં પાણી ભરીને આવળની છાલ, લુશ, મીરાબોળ નાખી એમાં ચામડાને પલાળીને કેળવું છું. એની બનતી ચીજો બનાવીને વેચું છું અને બીજા કારીગરોને ચીજો બનાવવા ચામડાં વેચાતાં પણ આપું છું. તેઓ વેચેલાં ચામડાંમાંથી વિવિધ જાતની વસ્તુઓ બનાવે છે. હું ચામડાનાં પખાલ અને કોશ બનાવું છું. કુલ્લાં બનાવું છું. પખાલ બાગ, બગીચા, ફૂલવારીના ક્યારામાં પાણી સીંચવા લઈ જાય છે. કુક્ષી તેલ ફુલેલ અને અત્તર સુગંધિત વસ્તુઓ ભરવા લઈ જાય છે અને મોટા કુલ્લાં તેલ- ઘી ભરવા લઈ જાય છે.
                          મોટા જમણવાર, સાધુસંતોના મંડપમેળા, સદાવ્રત ભંડારો કરવા માટે (તેલનો સંઘરો કરવા માટે ખાસ એ પ્રકારના કુલ્લાં વપરાય છે. જાત્રાના સંઘમાં પણ એનો ઉપયોગ થાય છે.
                          દેવસ્થાનમાં મોટા નગારાનું પડ-મઢન ચામડાનું હોય છે. એનો થોર નાદ કરવા માટે વાધર-વાઘરી એ મઢનને મજબૂત બાંધવા માટે વપરાય છે. પખવાજ, નરઘાં,

                        </p>
                        <p className="paragraph-content">
                          નોબત, ઢોલ, ત્રાંસા, તંબૂરા, ડાક, ડમરુ એવી ઘણી ચીજો બને છે. એ ગીત ચામડાને જુદી જુદી રીતે કેળવીને વેચું છું. મોશ ચામડું લઈને મોચી કારીય ઉપાન-પગરખાં મોજડી બનાવે છે. અમારો એ ધંધો છે.’ અખૈયાએ મોખર
                          તમામ વાત કરી.
                          ‘અખૈયા ! તું ભક્ત ગૌસેવક અને રામદેવજીનો આસ્તિક છે. તારા એ સંક તારી દીકરી ડાલીબાઈમાં ઊતર્યા છે. અમે એ કન્યાને ધણમાં દીઠી તેનો સ્વ તથા સેવાભાવ નિહાળ્યા. એની નમ્રતા અને વિનય જોઈ હું પ્રસન્ન થયો છું. હું એક અમારી ગૌશાળામાં મુક. અમારી ગૌશાળામાં બીજી પણ કન્યાઓ છે. અખાનું
                          ગાયો- વાછરું લઈને એ ગૌધણમાં જશે આવશે અને આનંદ કરશે.
                          મૂકી આવ્યો. ડાલીબાઈને પોતાના ભક્તિભાવ પ્રમાણે સગવડ મળી ગઈ. એને આ પ્રમાણે વીરમદેવજીનાં વચનો સાંભળી અખૈયો ડાલીબાઈને દરબારમાં ચપળતા અને સેવાભાવ જોઈ રામદેવજીના રામબાગના માળી લખમાએ તેને એક અગત્યનું કામ સોંપ્યું. રોજ સવારે લખમો માળી બાગમાંથી ફૂલછાબ ગૌશાળામ લાવીને ડાલીબાઈને આપી જાય. ડાલીબાઈ તરત હાર ગૂંથીને એ ફૂલહાર રાજમહેલમાં લઈ જાય. રામદેવજીને પુષ્પહાર પહેરાવી નમન કરે, પછી બીજ છાબડી અજમલજી અને વીરમદેવજીને પહોંચાડે. તે પછી એક હાર ‘રામેતી’ ગાયને પહેરાવે અને બપોરે નાનાં નાનાં વાછરું લઈ હેતથી હાંકતી હાંકતી ગામના પાદરે પાણી પાવા જાય અને સાંજે ગૌધણ સાથે પાછી આવે.
                          ડાલીબાઈ નિયમિત સેવા અને નમ્ર સ્વભાવથી માતા મિણલદેનો પ્રેમ એના પર વધતો ગયો. ગૌશાળા, રામબાગ અને રાજમહેલ સુધી ડાલીબાઈના સેવાભાવે આકર્ષણ જમાવ્યું. તેણે સઘળાનો પ્રેમ મેળવ્યો.
                          ‘ડાલીબાઈ ચમારની દીકરી છે. એનો છાંયો પડવાથી આભડછેટ લાગે છે, તો એને અડાય તો નહીં જ; આવા જડવાદી રૂઢીચુસ્તોમાં વાત વહેતી થઈ કે શૂદ્ર જાતિ ચમારની છોકરીને અજમલજીએ દાસી તરીકે રાણી પાસે રાખી છે. તે બાગમાંથી ફૂલો લઈ જાય છે અને એનાં અડકેલાં ફૂલો પૂજામાં દેવોને ચઢાવે છે. આ રીતે આભડછેટમાં પડીને અજમલજી ધર્મવિરુદ્ધ વર્તને કરે છે. એ આપણાથી સહનશી રીતે થાય ?’ આ પ્રમાણે એક વૃદ્ધ બ્રાહ્મણે બધાને એકઠા કરીને જણાવ્યું. બ્રાહ્મણોમાં ખળભળાટ થયો. આભડછેટની વાત રાઈનો પર્વત બની ગઈ અને બધા બ્રાહ્મણો અજમલજી પાસે ગયા.

                        </p>
                        <p className="paragraph-content">
                          દોહા
                          વિપ્ર થયા. સહુ એકઠા, ગયા રાજદરબાર,
                          નમન કરીને રાજવી, કરે સાદર-સત્કાર,
                          વેદના જ્ઞાતા, શાસ્ત્રી, પુરાણી, પંડિત, પુરોહિત જેવા વિદ્વાનો એકઠા પાસે આવ્યા. અજમલજી આવનાર બ્રાહ્મણોનું અંતર ઓળખી ગયા
                          ઈજજલઝ
                          • જો તમા સહુને નમન કરી ખૂબ આદર સત્કારથી - સન્માનથી આસનો જો જતાડ્યા અને તેમના આગમનનું કારણ પૂછ્યું.
                          દોહા
                          પંડિત પરમાનંદ કહે, અરજ સુણો મહારાજ,
                          ચમાર જાતિ ભેળવી, શીદ
                          અભડાવો રાજ?
                          પંડિત પરમાનંદના કથનને ટેકો આપતાં જટાશંકર શાસ્ત્રી બોલ્યા :
                          દોહા
                          વર્તન ધર્મવિરુદ્ધનું, કરી રહ્યા છો આપ!
                          અછૂત આભડછેટિયા, અડતાં લાગે પાપ.
                          અખૈયો ચમાર જાતિનો અછૂત છે એ આભડછેટિયાને અડતા પાપ લાગે. તેમ છતાં આપ એની દીકરીને રાજમહેલમાં આવવા-જવાની સગવડ આપીને ધર્મવિરુદ્ધ
                          રતન કરી રહ્યા છો !
                          ‘વિપ્રવર ! અકળાવ છો શા માટે ? શાંતિથી બેસો. હું ગુરુ બાળનાથને તેડાવું છું. ગામના મોભાદાર માણસોને તેડાવું છું. આપણે ધર્મચર્ચા કરવા સભા ભરીએ. મંજમલજીએ શાંતિથી કહ્યું.
                          અજમલજીએ માણસો મોકલી બાળનાથને તેડાવ્યા. ગામના પ્રતિષ્ઠિત મારાસો 8 હાજર થયા, ધર્મચર્ચા માટે મોટી સભા ભરાઈ. બાળનાથ સામે ધર્મચર્ચા કરવા શમ્યા. આ ધર્મચર્ચામાં શાસ્ત્રી, પુરાણીઓએ વાદવિવાદમાં ઊતરવા કમ્મર કસી.
                          દોહા
                          પંડિત સામે બેસતા, બાળનાથ સહ સાથે, ચર્ચા ચાલી ધર્મની, વિદ્વાનોની સાથ.
                          ભરી સભા સત્સંગની, બેઠા અજમલરાય,
                          ધર્મ, મર્મ ને કર્મના, વિચાર વિનિમય થાય.
                          ‘ભગવાન મનુએ મનુષ્ય જાતિમાં ચાર વર્ણ નક્કી કર્યા છે. બ્રાહ્મા, ક્ષત્રિય,

                        </p>
                        <p className="paragraph-content">
                          વૈશ્ય અને ૬. બ્રાહ્મણ મુખ, ક્ષત્રિય હાય, વૈશ્ય ઉદરે અન ગન્નાય છે.'
                          ‘પંડિતજી ! આપે એક અંગના ભાગ વર્ણવ્યા પરંતુ :-
                          ચોપાઈ
                          B
                          મનુ પહેલાં કર્યો વર્ણ ને જાતિ ? પંડિતજી માંગો મમ ક્રાંતિ, ધર્મ સનાતન છે. સહિયારો, કર્યો વર્ણએ ધર્મથી ન્યારો ? વિપ્રદેવ ! મનુ ભગવાને ચારે વર્ણમાં અંગના વિભાગ બતાવ્યા. એ અંગો ચારે વર્ણમાં એક સરખા છે. ચરણ ચૂદ્ર હોય તો શું ? બ્રાહ્મણોને ચરણ નથી ! અને કર્યો વર્ણ છે કે જેને માત્ર એક જ અંગ છે. અને ધર્મ તો સહુનો સહિયારો છે.
                          ધર્મથી કર્યો વર્ણ જુદો છે ? મ
                          ચોપાઈ..
                          બ્રાહ્મણ, ક્ષત્રી, વૈશ્ય કહાવે, શૂદ્ર જાતને ચરણ બતાવે! શીર કર ઉત્તર મહાન ગણાવે, કેમ ચરણમાં શીશી નમાવે? ચરણને શૂદ્ર ગણી નીચી કોટિનાં ગણાવ્યા છે. તો એ ચરણોમાં ચારે વહેં મસ્તક નમાવી ગુરુજનોની ચરણપૂજા કરે છે, એનું શું કારણ ? બધાં શૂદ્રને ન છે ?’ બાળનાથે પૂછ્યું!
                          ચોપાઈ
                          ચરણો ભાર ત્રણેનો ઘરતા, મન દોરે ત્યાં એ વિચરતા,
                          હોયે માનવ ચરણ વિનાનો, વ્યર્થ જીવન તેનું શું માનો? પંડિતજી ! પગને શૂદ્ર ગણી રહ્યા છો ! પરંતુ માથાનો, હાથનો અને ઉદરન ભાગ જે કમ્મર ઉપરનો છે તે ત્રણે ભાગનો ભાર પગ ઉપાડે છે, એવી એમની પરોપકાર વૃત્તિ છે. સેવાભાવની ભક્તિ છે. વળી મન દોરે ત્યાં ત્રણેનો બોજ ઊંચકીને ચરણ જ એમને સેવાભાવે લઈ જાય છે, છતાં તમે મનુ ભગવાનના નામે પાર વર્ણના વિભાગનો દાખલો આપો છો ? તમે પંડિત થયા, શાસ્ત્ર પુરાણી થય પણ વર્ણ ધર્મનો મર્મ સમજી શક્યા નહીં.'
                          દોહા 
    
                          મનુએ વિગતે વર્ણવ્યા, માનવ વર્ણો ચાર,
                          પોલા બોલા બોધથી, થયા વરણ અઢાર.
                          મનુ ભગવાનની ચાર વર્ણની જે સમજૂતી છે, તે તમે સમજ્યા વિના પોથાંમાં

                        </p>
                        <p className="paragraph-content">
                          ખાં છે વિપ્રવર ! તમે સનાતન ધર્મ, કર્મનો બોધ કરો છો પણ એ બોલ જે. માનવ માનવને અડતાં અભડાય ? એ આભડછેટ શું છે ? એ કહ્યું .
                          /
                          કોઈનો રંગ બદલાઈ જાય છે કે શું ?' એ પ્રમાણે ગુરુ બાળનાથે કહ્યું સાંભળી પંડિત પરમાનંદ મનમાં ધૂંધવાઈ ગયો અને બોલી
                          13 જા? | નાથની વાત
                          દોહા
                          ચામડ-ચૂંથો માનવી, અખૈયો જાત ચમાર,
                          ડાલી એની દીકરી, દાસી મહેલ મોજાર. મહત્વનું . આપ માત્ર યોગમાં પારંગત છો, પરંતુ કર્મ પ્રમાણે ધર્મ ગણાય બની છે. એને અડતાં સ્નાન કરી પવિત્ર થવું પડે છે, કારણ કે એ અપવિત્ર શૂ - અર્ગો જાતનો ચમાર છે. રાત દિવસ ચામડાં ચૂંથવાનો ધંધો કરે છે. એ અદ્ભૂત રખર ગણાય. આવા શુદ્રની દીકરીને રાજમહેલમાં દાસી રાખી અજમલજીએ બાળનાથ શાંતિથી બોલ્યા : ‘પુરાણીજી, અકળાઈને વાત કરો મા ! ભગવાને વેશ્યા પુત્ર, કોઈ ઢીંમર પુત્ર, કોઈ માછી પુત્ર અને કોઈ ભીલપુત્ર હતા. તમે વતાર લીધો, મચ્છાવતાર લીધો, આપણા મહાન ધર્મધુરંધર મહર્ષિઓમાં નાં પુરાણી છો. અઢાર પુરાણના અભ્યાસી છો. છત અને અછૂતનો ભેદ તમારા ના વિદ્વાનો ગણે છે, ત્યારે તમારા જ્ઞાન અને અભ્યાસમાં ઊન્નપ જણાય છે,
                          ગનું રાજ અભડાવ્યું છે.
                          કારણ કે –
                          દોહા
                          ઇડર અડવું કે ઉછેટવું, સ્પર્શ કે આભડછેટ,
                          અછૂત ઉદર વૈશ્યનું, જુઓ તપાસી પેટ,
                          અડવું કે ઉછેટવું એ બંને ધર્મનાં બહાનાં છે. કોઈ વિદ્વાન સંતોએ સમજાવ્યું છે - જે અંગમાં મળ છે તે ઉદર વૈશ્યના સ્થાનમાં છે. મળ-મૂત્ર પવિત્ર ગણાતું નથી. માં તેને ત્રીજા વર્ણનો ગણ્યો અને પગને શૂદ્ર તથા અશુદ્ધ ગણ્યા. એનાં કારણો |ામવા કોઈ શાસ્ત્ર ધર્મગ્રંથનો અભ્યાસ કરી. કારણ કે;
                          દોહા
                          જીવાત્મામાં શ્રેષ્ઠ છે, માનવ દેહ અમોલ, અન્ય પ્રાણીઓ જગતમાં, નથી માનવને તોલ.


                        </p>
                        <p className="paragraph-content">
                          કર્મ જ જેવી વાતો કરીને ----
                          આત્મા થાય. મહાત્મા, પરમાત્મા
                          યે
                          થાય,
                          માનવ ભક્તિબળ થકી, બ્રહ્મલીન થઈ જાય.
                          માનવ ભક્તિની શક્તિથી આગળ વધે છે. આત્મા મહાત્મા મહાત્મા-પરમાત્મા થાય અને બ્રહ્મલીન પણ બને છે, એવા માનવદેહને હોતા નથી. આવા હલકા વિચારો રાખનાર પોતે જ શૂદ્ર ગણાય છે. આવા બળત કોટિનો ગણનારા બકવાદી, તર્કવાદી અને વિતંડાવાદી હોય છે. સમાનતા
                          મેલા માનવીની છાયા લેવી એ જ મોટી આભડછેટ છે. //////
                          દોહા
                          અનેકવિધ વૃક્ષો રહ્યાં, રંગે લીલા પર્ણ,
                          પનુએ દીધો દાખલો, માનવ એક જ વર્ણ.
                          અનેક વૃક્ષો વનરાઈ જોઈએ તો સર્વનાં ફળ રંગબેરંગી હોય છે, પણ પાન લીલા રંગના જ હોય છે. એમ માનવદેહના ચાર વિભાગનું વર્ણન મનુ ભગવ એક જ વર્ણના શરીરમાં કરેલું છે, પંડિત ! સ્વાનુભવની વાત કહું ? સાંભળો
                          દોહા
                          શ્વાન અને મંજારનો, થાય સદનમાં પોષ,
                          માનવને માનવ મંહી, અડતાં ગણો ન દોષ.
                          ‘શ્વાન અને બિલાડી ઘેર ઘેર જાય છે ને આવે છે. એ અભક્ષ્ય ખાય છે. ગમે ઘરમાંથી તમારા ઘરમાં આવે છે અને રહે છે તથા પોષાય છે. તો પછી માત્ર માણસને અડતાં દોષીત થાય છે, આ કવું શાસ્ત્ર ?'
                          બાળનાથની સ્પષ્ટ વાત સાંભળી ધર્મસંવાદમાં ભૂદેવો ઠંડા પડ્યા. એટલે એમણે સાવ સાદી વાતથી એમનું ધ્યાન દોર્યું : ‘ચમાર-ચર્મકારનો સૌના ઉપર મોટો ઉપકાર છે. શિવજીનું ડમરું, ભવાનીનું ડાકલું, ત્રાજવાં, ત્રાંસા, દેવળનું ઢોલ, નગાર પટહ, પખવાજ, કુડલાં, કોશ, પખાલ વગેરે બનાવી તમારી સગવડ સાચવે છે. ત્યારે તમે એને અપમાનની નજરે જુઓ એ તમારી વિદ્વતા નથી. ઊંચનીચનો ભે રાખો છો પણ દાનદક્ષિણા બુદ્ધિથી તમે આભડછેટનું તૂત ઊભું કરી અહીં ભ પધાર્યા. અખૈયાનું ઘર ભક્તિભાવવાળું પવિત્ર છે. રોહીદાસ ચમારને મીરાંબાઈમે પોતાના ગુરુ કર્યાં હતા. એવા અનેક સંતો છે, જે તમારાથી વિશેષ ધર્મ, કર્મ અને ભક્તિના પ્રદેશમાં હોય છે. તમે દિશા ભૂલો મા ! તમે ભવરણમાં ભૂલા પડેલા હવે ખરો રસ્તો પકડો.' બાળનાથે માર્ગદર્શક વાણી કહી ઠપકો પણ આપ્યો અને


                        </p>
                        <p className="paragraph-content">
                          બાળનાથના દૃષ્ટાંત બોધથી ચૂપ થઈ અને વિઘ્નસંતોષીએ
                          કચ્છનું ભૂત ઊભું કરી માનવથી જુદા પાડી દેવા તેમણે કૌભાંડ અને દુષ્કૃત્ય છે. અને સર્વન સમજાયું. સૌએ પોતાની ભૂલ કબૂલ કરી. બાળનાથે છેલ્લો
                          આપ્યો કે :-
                          ચોપાઈ
                          પામર પ્રાણી મૃગલાં વનનાં, મારે દયા ન રાખે મનમાં, નાભી મળ કસ્તુરી કહાવે, પંડિત જન સૌ ખાંતે ખાવે.
                          કસ્તુરી મૃગ જે બિચારો માનવીને નડતો નથી, માનવીના વસવાટની ભૂમિથી જ્ડ વેરાન ભૂમિમાં પડી રહે છે. માનવનો ખોરાક અન્ન પણ ખાતો નથી ઠાની નાભિમાંના મેલને કસ્તુરી કહી પંડિતો, ધર્માચાર્યો ખાંતેથી ખાય છે અને રે ઘાસ ખાઈને જીવે છે, એવા નિરપરાધી જીવને મારી નંખાવી એ મૃગના બના ચામડાનો આસન તરીકે ઉપયોગ કરે છે ! વ્યાઘ્ર ચર્મ પણ ચર્મકાર જ આપે કૂવામાંથી પાણી કોશ વડે જ નીકળે છે કે જેનાથી અન્નના ખેતરમાં પાણી પવાય ખાલ વડે કૂવામાંથી પાણી લઈ જવાય છે ને ફૂલવાડીમાં અપાય છે, પગનાં કક ઉપાન-પગરખાં એ પણ ચમાર પાસેથી મળે છે. ઘોડાની વાગ, બળદનાં તરાં, શૌરવિધિ કરનાર અસ્ત્રાને તેજસ્વી ધારનો બનાવવા માટે પણ ચામડાનો રૂડો વાપરે છે. કોઈ ઘર એવું નથી કે જે ઘરમાં ચમાર પાસેથી મેળવેલી વસ્તુ ના ય. બાળનાથનાં સચોટ બોધવચનો સૌનાં હૃદયમાં સોંસરાં ઊતરી ગયાં. તે દિવસે પૂર્વ બ્રાહ્મણોનો ભ્રમ ભાંગી ગયો !
                          દોહા
                          વિપ્રોનો ભ્રમ ભાંગતા, બાળનાથ અવધૂત,
                          મરુ દેશમાંથી ગયું, આભડછેટનું ભૂત.
                          ગુરુ બાળનાથના સચોટ ઉપદેશ આગળ પંડિતોનું કંઈ ચાલ્યું નહીં. છેવટે બધા થઈ ગયા અને અત્યાર સુધી બીજી વર્ણો ઉપર તેમણે જે અત્યાચાર કર્યો તે માટે ો પસ્તાવા લાગ્યા.
                          આખીયે સભા ગુરુ બાળનાથની વાણી સાંભળી તેમનો જય જયકાર બોલી
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>{" "}
        </div>
      </div>
      {/* </div>
      </div> */}
      <div>
        <Footer />
        {/* <AudioPlayer state={props.state} onPlay={(isPlay) => this.setState({ isPlay })} /> */}
      </div>
    </>
  );
};

export default BlogDetails12;
